"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var TableMenuIsLocked_1 = require("../../../../../../shared/components/table_menus/TableMenuIsLocked");
var CmsBotsList = /** @class */ (function (_super) {
    __extends(CmsBotsList, _super);
    function CmsBotsList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchTitleInput = null;
        return _this;
    }
    CmsBotsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            searchTitleFilter: [],
            searchTitleValue: ""
        }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    CmsBotsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    CmsBotsList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                nextProps.data.LoadData(_this.props.allBrands, _this.props.brandsList);
            });
        }
    };
    CmsBotsList.prototype.doLockUnlockAction = function (Key, Title, Lock) {
        this.props.data.doSetIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u043E\u0442 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u043E\u0442 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    CmsBotsList.prototype.onClearTitleFilter = function () {
        this.setState({ searchTitleFilter: [], searchTitleValue: "" });
    };
    CmsBotsList.prototype.onChangeTitleFilter = function (e) {
        this.setState({ searchTitleValue: e.target.value });
    };
    CmsBotsList.prototype.onConfirmTitleFilter = function () {
        this.setState({ searchTitleFilter: [this.state.searchTitleValue] });
    };
    CmsBotsList.prototype.getColumns = function () {
        var _this = this;
        var _title_filter = this.state.searchTitleFilter;
        return [{
                title: 'Тэг бота',
                dataIndex: this.props.data.dk_bot_tag,
                key: this.props.data.dk_bot_tag,
                width: 150,
            }, {
                title: 'Логин бота',
                dataIndex: this.props.data.dk_usr_player_login,
                key: this.props.data.dk_usr_player_login,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchTitleInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043B\u043E\u0433\u0438\u043D\u0443", value: _this.state.searchTitleValue, onChange: _this.onChangeTitleFilter.bind(_this), onPressEnter: function () { _this.onConfirmTitleFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmTitleFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearTitleFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _title_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.usr_player_login.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchTitleInput.focus();
                        });
                    }
                }
            }, {
                title: 'Бренд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                width: 150,
            }, {
                title: 'Набор игр',
                dataIndex: this.props.data.dk_cms_gameprovider_gameset_title,
                key: this.props.data.dk_cms_gameprovider_gameset_title,
                width: 150,
            }, {
                title: 'Игра',
                dataIndex: this.props.data.dk_gws_gameprovider_game_title,
                key: this.props.data.dk_gws_gameprovider_game_title,
                width: 200,
            }, {
                title: 'Интервал (min/max)',
                dataIndex: this.props.data.dk_min_timeout_win_sec,
                key: this.props.data.dk_min_timeout_win_sec,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.min_timeout_win_sec,
                        "/",
                        record.max_timeout_win_sec,
                        " \u0441\u0435\u043A."));
                },
            }, {
                title: 'Выигрыш (min/max)',
                dataIndex: this.props.data.dk_min_win_amount,
                key: this.props.data.dk_min_win_amount,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.min_win_amount,
                        "/",
                        record.max_win_amount,
                        " ",
                        record.app_currency_iso));
                },
                width: 150,
            }, {
                title: 'Смена игры (min/max)',
                dataIndex: this.props.data.dk_change_game_min_timeout_sec,
                key: this.props.data.dk_change_game_min_timeout_sec,
                render: function (text, record, idx) {
                    if (record.is_auto_change_game) {
                        return (React.createElement("div", null,
                            record.change_game_min_timeout_sec,
                            "/",
                            record.change_game_max_timeout_sec,
                            " \u0441\u0435\u043A."));
                    }
                    else {
                        return (React.createElement("div", null, "\u043D\u0435\u0442"));
                    }
                },
                width: 150,
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { unlockedTexts: { menu: "Разблокировать бота", text: "Нет" }, lockedTexts: { menu: "Заблокировать бота", text: "Да" }, record: { key: record.key, title: record.usr_player_login, locked: record.is_locked }, onLockClick: _this.doLockUnlockAction.bind(_this) }));
                },
                width: 150
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 110
            }];
    };
    CmsBotsList.prototype.onEditClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    CmsBotsList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041F\u043E\u0431\u0435\u0434\u0438\u0442\u0435\u043B\u044C ",
                React.createElement("b", null,
                    "[",
                    record.usr_player_login,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    CmsBotsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    CmsBotsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.allBrands, this.props.brandsList);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    CmsBotsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    CmsBotsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added2.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                            "]")));
                }, scroll: { x: true } })));
    };
    return CmsBotsList;
}(React.Component));
exports.default = CmsBotsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_bots/ui/component/CmsBotsList.tsx
// module id = 2333
// module chunks = 0